export enum UserManagement {
  Workday = 'workday',
  Evisort = 'evisort',
}
